/**
 * Internal dependencies
 */
import { SECTION_SET }  from "state/action-types";
import { ROUTE_SET } from "state/action-types";

export { openModal, createCloseModalAction, createOpenModalAction, closeModal } from './modal/actions';


/**
 * Returns an action object signalling that the current route is to be changed
 *
 * @param  {String} path    Route path
 * @param  {Object} [query] Query arguments
 * @return {Object}         Action object
 */
export function setRoute( path, query = {} ) {
    return {
        type: ROUTE_SET,
        path,
        query,
    };
}


export function setSection( section, options = {} ) {
	options.type = SECTION_SET;

	if ( section ) {
		options.section = section;
	}

	options.hasSidebar = options.hasSidebar === false ? false : true;
	
	return options;
}